import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Input, Select } from 'antd';
import PasswordInput from '../../../components/PasswordInput';
import { UserRole } from '../../../types/types';

const { Option } = Select;

class LeftSide extends Component {
    constructor(props) {
        super(props);
        const { profile } = props;

        this.state = {
            name: profile.name,
            email: profile.email,
            role: profile.role,
            department: profile.department,
            division: profile.division,
            status: profile.status,
            password: null,
            passwordError: null,
            two_factor_auth: profile.two_factor_auth,
            passwordIsHidden: true,
        };
    }

    componentDidUpdate(prevProps) {
        const { profile } = this.props;
        const { profile: oldProfile } = prevProps;

        if (
            oldProfile.name !== profile.name ||
            oldProfile.email !== profile.email ||
            oldProfile.role !== profile.role ||
            oldProfile.department !== profile.department ||
            oldProfile.division !== profile.division ||
            oldProfile.status !== profile.status ||
            oldProfile.two_factor_auth !== profile.two_factor_auth
        ) {
            this.setState({
                name: profile.name,
                email: profile.email,
                role: profile.role,
                department: profile.department,
                division: profile.division,
                status: profile.status,
                password: null,
                two_factor_auth: profile.two_factor_auth,
            });
        }
    }

    componentDidMount() {
        const { registerGetDetailsHandler } = this.props;

        registerGetDetailsHandler(this.getDetails);
    }

    humanReadableRole(role) {
        return role.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
    }

    getDetails = () => {
        const {
            name,
            email,
            role,
            department,
            division,
            status,
            password,
            two_factor_auth,
        } = this.state;

        return {
            name,
            email,
            role,
            department,
            division,
            status,
            password,
            two_factor_auth,
        };
    }

    render() {
        const {
            name,
            email,
            role,
            status,
            password,
            two_factor_auth,
        } = this.state;
        const { currentUserRole } = this.props;

        let disableRoleSelection = false;
        if (currentUserRole === UserRole.Manager && role !== UserRole.User) {
            disableRoleSelection = true;
        }
        if (currentUserRole === UserRole.Admin && [UserRole.User, UserRole.Admin].includes(role)) {
            disableRoleSelection = true;
        }
        if (currentUserRole === UserRole.SalesAdmin && [UserRole.User, UserRole.SalesAdmin].includes(role)) {
            disableRoleSelection = true;
        }
        let roleComponent = disableRoleSelection ? (
            <p>{this.humanReadableRole(role)}</p>
        ) : (
            <Select
                value={role}
                onChange={(v) => this.setState({ role: v })}
                style={{ width: '100%' }}
            >
                {[UserRole.SuperAdmin, UserRole.Admin, UserRole.SalesAdmin].includes(currentUserRole)
                    ? <Option value={UserRole.Manager}>Manager</Option>
                    : null
                }
                <Option value="user">User</Option>
            </Select>
        );
        const showEditPassword =
            ([UserRole.SuperAdmin, UserRole.Admin, UserRole.SalesAdmin].includes(currentUserRole)) &&
            ([UserRole.User, UserRole.Driver, UserRole.Manager].includes(role));
        const showEditTwoFactorAuth = showEditPassword && two_factor_auth !== undefined;

        return (
            <ul className="list left-side-user-list">
                <li className="list__item">
                    <div className="list__item-name">
                        Name:
                    </div>
                    <div className="list__item-value">
                        <Input value={name} onChange={(v) => this.setState({ name: v.target.value })} />
                    </div>
                </li>
                <li className="list__item">
                    <div className="list__item-name">
                        Email:
                    </div>
                    <div className="list__item-value">
                        <Input value={email} onChange={(v) => this.setState({ email: v.target.value })} />
                    </div>
                </li>
                <li className="list__item">
                    <div className="list__item-name">
                        Role:
                    </div>
                    <div className="list__item-value">
                        {roleComponent}
                    </div>
                </li>
                <li className="list__item">
                    <div className="list__item-name">
                        Status:
                    </div>
                    <div className="list__item-value">
                        <Select
                            value={`${status}`}
                            onChange={(v) => this.setState({ status: parseInt(v, 10) })}
                            style={{ width: '100%' }}
                        >
                            <Option value="1">Active</Option>
                            <Option value="0">Inactive</Option>
                        </Select>
                    </div>
                </li>
                {showEditPassword && (
                    <li className="list__item">
                        <div className="list__item-name">
                            New Password:
                        </div>
                        <div className="list__item-value">
                            <PasswordInput
                                value={password}
                                onChange={(v) => {
                                    const newPassword = v.target.value;
                                    let error = null;
                                    if (newPassword.length < 8) {
                                        error = 'A new password must be at least 8 characters length!\n\r';
                                    } else if (newPassword.match(/\d+/) === null) {
                                        error = 'Must contain at least 1 digit\n\r';
                                    } else if (newPassword.match(/[A-Z]+/) === null) {
                                        error = 'Must contain at least 1 uppercase character\n\r';
                                    } else if (newPassword.match(/[a-z]+/) === null) {
                                        error = 'Must contain at least 1 lowercase character\n\r';
                                    } else if (newPassword.match(/[!#$@%\-_=+<>\'"`£^&¬\.*\(\)\[\]\?:;\/,{}]/) === null) {
                                        error = 'Must contain at least 1 special character';
                                    }
                                    this.setState({
                                        password: v.target.value,
                                        passwordError: error,
                                    });
                                }}
                            />
                        </div>
                        {this.state.passwordError && (
                            <div style={{
                                color: 'red',
                                marginTop: '8px',
                                marginLeft: '8px',
                                fontSize: '12px',
                            }}>
                                {this.state.passwordError}
                            </div>
                        )}
                    </li>
                )}
                {showEditTwoFactorAuth ? (
                    <li className="list__item">
                        <div className="list__item-name">
                            <Checkbox
                                defaultChecked={two_factor_auth > 0}
                                onChange={(value) => { this.setState({ two_factor_auth: value.target.checked ? 1 : 0 }) }}
                            />
                            &ensp;
                            Enable Two-factor Authentication?
                        </div>
                    </li>
                ) : null}
            </ul>
        );
    }
}

LeftSide.defaultProps = {
    currentUserRole: '',
    departments: [],
    profile: {
        name: '',
        email: '',
        role: '',
        department: '',
        division: 1,
        status: 1,
    },
    registerGetDetailsHandler: () => null,
};

LeftSide.propTypes = {
    currentUserRole: PropTypes.string.isRequired,
    departments: PropTypes.array.isRequired,
    registerGetDetailsHandler: PropTypes.func,
    profile: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string,
        role: PropTypes.string,
        department: PropTypes.string,
        division: PropTypes.number,
        status: PropTypes.number,
    }),
};

export default LeftSide;
